export const paymentOptions = [
    {id: 'year', label: 'Yearly payment'},
    {id: 'month', label: 'Monthly payment'},
];

export const currencies = [
    {'@id': '/web_api/currency/CHF', code: 'CHF'},
    {'@id': '/web_api/currency/EUR', code: 'EUR'},
];
